import React, { useState, useEffect } from "react";
import Canvas from '@antv/f2-react';
import { Chart, Axis, Interval, Tooltip } from '@antv/f2';
import { Card, Space, ProgressCircle } from 'antd-mobile';
import api from '../../api';
import styles from "./style.less";

const Report = () => {
  const [orderData, setOrderData] = useState([])
  const [todayOrderData, setTodayOrderData] = useState()

  const refreshOrderData = async () => {
    const resp = await api.orderDashboardData()
    if (resp?.data?.code === 0) {
      const datan = resp.data.data.map(dto => {
        dto.totalKwh = dto.totalKwh / 1000 / 3600;
        dto.date = dto.date.substring(5);
        dto.totalPayFee = dto.totalPayFee / 100;
        dto.totalChargingFee = dto.totalChargingFee / 100;
        dto.totalRefundFee = dto.totalRefundFee / 100;
        dto.totalActualFee = dto.totalActualFee / 100;
        dto.totalCancelFee = dto.totalCancelFee / 100;
        return dto;
      })
      setOrderData(datan)
      setTodayOrderData(datan[datan.length - 1])
    }
  }

  useEffect(() => {
    refreshOrderData()
  }, [])

  if (!orderData || orderData.length == 0) {
    return null
  }

  return (
    <div>
      <Card title="今日订单">
        <Space style={{ '--gap': '5vw' }}>
          <ProgressCircle
            percent={100}
            style={{
              '--size': '20vw',
              '--fill-color': 'var(--adm-color-primary)',
            }}
          >
            <div className={styles.secondaryText}>订单总数</div>
            <div className={styles.mainText}>{todayOrderData.totalCount}</div>
          </ProgressCircle>
          <ProgressCircle
            percent={100}
            style={{
              '--size': '20vw',
              '--fill-color': 'var(--adm-color-warning)',
            }}
          >
            <div className={styles.secondaryText}>进行中</div>
            <div className={styles.mainText}>{todayOrderData.chargingCount + todayOrderData.createCount + todayOrderData.paidCount}</div>
          </ProgressCircle>
          <ProgressCircle
            percent={100}
            style={{
              '--size': '20vw',
              '--fill-color': 'var(--adm-color-success)',
            }}
          >
            <div className={styles.secondaryText}>已完成</div>
            <div className={styles.mainText}>{todayOrderData.finishCount + todayOrderData.partialRefundCount}</div>
          </ProgressCircle>
          <ProgressCircle
            percent={100}
            style={{
              '--size': '20vw',
              '--fill-color': 'var(--adm-color-danger)',
            }}
          >
            <div className={styles.secondaryText}>退款/取消</div>
            <div className={styles.mainText}>{todayOrderData.cancelCount + todayOrderData.totalRefundCount}</div>
          </ProgressCircle>
        </Space>
      </Card>

      <Card title="今日金额">
        <Space style={{ '--gap': '5vw' }}>
          <ProgressCircle
            percent={100}
            style={{
              '--size': '20vw',
              '--fill-color': 'var(--adm-color-primary)',
            }}
          >
            <div className={styles.secondaryText}>支付金额</div>
            <div className={styles.mainText}>{todayOrderData.totalPayFee}</div>
          </ProgressCircle>
          <ProgressCircle
            percent={100}
            style={{
              '--size': '20vw',
              '--fill-color': 'var(--adm-color-warning)',
            }}
          >
            <div className={styles.secondaryText}>充电中金额</div>
            <div className={styles.mainText}>{todayOrderData.totalChargingFee}</div>
          </ProgressCircle>
          <ProgressCircle
            percent={100}
            style={{
              '--size': '20vw',
              '--fill-color': 'var(--adm-color-success)',
            }}
          >
            <div className={styles.secondaryText}>实际消费</div>
            <div className={styles.mainText}>{todayOrderData.totalActualFee}</div>
          </ProgressCircle>
          <ProgressCircle
            percent={100}
            style={{
              '--size': '20vw',
              '--fill-color': 'var(--adm-color-danger)',
            }}
          >
            <div className={styles.secondaryText}>退款/取消</div>
            <div className={styles.mainText}>{todayOrderData.totalRefundFee + todayOrderData.totalCancelFee}</div>
          </ProgressCircle>
        </Space>
      </Card>

      <Card title="近7日订单数量">
        <Canvas>
          <Chart
            data={orderData}
            scale={{
              totalCount: {
                tickCount: 5,
              },
            }}
          >
            <Axis field="date" />
            <Axis field="totalCount" />
            <Interval x="date" y="totalCount" color="l(90) 0:#1890ff 1:#70cdd0" />
            <Tooltip />
          </Chart>
        </Canvas>
      </Card>

      <Card title="近7日实际消费金额">
        <Canvas>
          <Chart
            data={orderData}
            scale={{
              totalActualFee: {
                tickCount: 5,
              },
            }}
          >
            <Axis field="date" />
            <Axis field="totalActualFee" />
            <Interval x="date" y="totalActualFee" color="l(90) 0:#1890ff 1:#70cdd0" />
            <Tooltip />
          </Chart>
        </Canvas>
      </Card>

      <Card title="近7日用电量">
        <Canvas>
          <Chart
            data={orderData}
            scale={{
              totalKwh: {
                tickCount: 5,
              },
            }}
          >
            <Axis field="date" />
            <Axis field="totalKwh" />
            <Interval x="date" y="totalKwh" color="l(90) 0:#1890ff 1:#70cdd0" />
            <Tooltip />
          </Chart>
        </Canvas>
      </Card>
    </div>
  )
}

export default Report